const SamplesImageBlock = ({ className }: { className?: string }) => (
  <svg
    width={220}
    height={125}
    viewBox="0 0 220 125"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="m190.547 54.773 7.439 1.274.278 2.371 2.414.363 1.117-1.935 7.154 1.257 6.041 37.751-2.106 3.648-38.763-5.948-.785-38.18.798-1.382 3.652.562 1.181-2.045 7.889 1.386.171 2.383 2.513.493z"
      fill="#EAE9ED"
    />
    <path
      d="m190.547 54.773 3.405 37.851m-3.405-37.85 7.439 1.273.278 2.371m-7.717-3.645-1.007 1.998m4.412 35.853 8.491 1.366m-8.491-1.366-1.148 1.99m9.639-.624-1.053 1.823 4.062.872m-3.009-2.695-4.179-35.572m7.188 38.267 1.245-2.155m-1.245 2.155-4.774-37.904m6.019 35.749-4.902-37.684m4.902 37.684 8.293 1.324m-13.195-39.008 7.154 1.257 6.041 37.751m-13.195-39.008-1.117 1.935m14.312 37.073-2.106 3.648-38.763-5.948m26.557-34.773-2.414-.363m-8.724-1.647-2.513-.493m2.513.493 3.264 37.843m-5.777-38.336-.171-2.383-7.889-1.386m8.06 3.77 2.395 35.646m-10.455-39.416 1.625 38.002m-1.625-38.002-1.181 2.045m2.806 35.957 8.83 1.414m-8.83-1.414-1.085 1.879m9.915-.465-1.085 1.879 4.467.81m-13.297-2.224-4.333-.66m4.333.66-1.721-37.836m-2.612 37.177-1.04-37.739m1.04 37.739-1.053 1.823m.013-39.562 3.652.562m-3.652-.562-.798 1.382.785 38.18"
      stroke="#292747"
      strokeWidth={0.7}
      strokeLinejoin="round"
    />
    <path
      d="m193.952 92.624-3.405-37.85 7.439 1.273.278 2.371 4.179 35.572zm7.843-35.777 4.902 37.683 8.293 1.324-6.041-37.75zm-14.939-2.952.171 2.383 2.395 35.647-8.83-1.414-1.625-38.002z"
      fill="#EAE9ED"
    />
    <path
      d="m214.99 95.854-6.041-37.75-7.154-1.258 4.902 37.684zm0 0-2.106 3.648-38.762-5.948m4.845-41.045 7.889 1.386.171 2.383 2.395 35.647-8.83-1.414zm0 0-1.18 2.045m12.76.22 3.405 37.85 8.491 1.366-4.179-35.572-.278-2.371z"
      stroke="#292747"
      strokeWidth={0.7}
      strokeLinejoin="round"
    />
    <path
      d="m121.751 56.348 8.513-6.024 2.589 2.045 2.713-2.005-.799-2.981 8.217-5.762 42.787 30.983 1.506 5.621-43.683 32.061-38.071-36.536-.571-2.13 4.117-3.02-.844-3.15 9.062-6.355 2.495 2.162 2.938-1.974z"
      fill="#EAE9ED"
    />
    <path
      d="m121.751 56.348 40.309 33.654m-40.309-33.654 8.513-6.024 2.589 2.045m-11.102 3.979.969 2.935m39.34 30.72 9.63-6.962m-9.63 6.961.822 3.067m8.808-10.028.753 2.81 4.821-3.117m-5.574.307-38.837-30.672m44.411 30.365-.89-3.322m.89 3.322-41.698-32.37m40.808 29.048-41.607-32.029m41.607 32.03 9.397-6.81m-51.004-25.22 8.217-5.762 42.787 30.983m-51.004-25.221.799 2.981m50.205 22.24 1.506 5.621-43.683 32.061m-8.028-59.922-2.713 2.005m-10.133 6.914-2.938 1.974m2.938-1.974 40.162 33.786m-43.1-31.812-2.495-2.161-9.062 6.353m11.557-4.192 37.169 32.488m-48.726-28.296 38.717 35.542m-38.717-35.542.844 3.151m37.873 32.391 10.009-7.246m-10.009 7.246.775 2.896m9.234-10.142.776 2.896 5.155-3.573m-15.165 10.819-4.877 3.589m4.877-3.589L109.069 68.6m33.771 38.876-37.888-35.855m37.888 35.855.754 2.81m-38.642-38.665 4.117-3.02m-4.117 3.02.571 2.129 38.071 36.536"
      stroke="#292747"
      strokeLinejoin="round"
    />
    <path
      d="m162.06 90.003-40.309-33.655 8.513-6.024 2.589 2.045L171.69 83.04zm-27.293-42.62 41.607 32.03 9.397-6.81-42.787-30.982zm-17.48 11.713 2.495 2.16 37.169 32.489-10.009 7.246-38.717-35.542z"
      fill="#D4D4DA"
    />
    <path
      d="M185.771 72.604 142.984 41.62l-8.217 5.762 41.607 32.03zm0 0 1.506 5.621-43.683 32.061m-35.369-44.837 9.062-6.353 2.495 2.16 37.169 32.489-10.009 7.246zm0 0 .844 3.151m12.682-12.252 40.309 33.655 9.63-6.962-38.837-30.672-2.589-2.045z"
      stroke="#292747"
      strokeLinejoin="round"
    />
    <path
      d="M6.766 89.884 4.37 82.727l1.958-1.367-.823-2.298-2.232-.07-2.277-6.897 30.405-23.177 4.21.13 13.093 36.966-33.269 18.75-1.594-.05-1.233-3.483-2.36-.073-2.51-7.607 2.019-1.278-.754-2.447z"
      fill="#EAE9ED"
    />
    <path
      d="m6.766 89.884 31.74-20.903M6.765 89.884 4.37 82.727l1.958-1.367m.438 8.524 2.237-.058M38.505 68.98l-2.813-8.126m2.813 8.126 2.296.071m-5.109-8.197 2.105.065-1.153-3.992m-.952 3.927L6.328 81.36m30.316-24.432-2.488-.077m2.488.077L5.505 79.062m28.651-22.21L3.273 78.991m30.883-22.14-2.755-7.934M3.273 78.993.996 72.095l30.405-23.177M3.273 78.993l2.232.069m25.896-30.144 4.21.13 13.093 36.966M5.505 79.062l.823 2.298m2.675 8.466.754 2.448m-.754-2.448L40.8 69.052M9.757 92.273l-2.019 1.278 2.51 7.607m-.491-8.885 30.275-18.97m-29.784 27.855 32.714-19.406m-32.714 19.406 2.36.073m30.354-19.478-2.93-8.45m2.93 8.45 2.169.067m-5.1-8.517 2.17.068-1.4-4.319m4.33 12.768 1.468 4.129m-1.468-4.13-32.523 19.412m33.991-15.282-32.758 18.765m32.758-18.765 2.105.065m-34.863 18.7-1.233-3.483m1.233 3.483 1.594.05 33.269-18.75"
      stroke="#292747"
      strokeWidth={0.7}
      strokeLinejoin="round"
    />
    <path
      d="M38.505 68.981 6.766 89.884 4.37 82.727l1.958-1.367 29.364-20.505zM3.273 78.993 34.156 56.85l-2.755-7.933L.996 72.095zM7.738 93.55l2.019-1.277 30.275-18.97 2.93 8.45-32.714 19.405z"
      fill="#D4D4DA"
    />
    <path
      d="M31.401 48.918.996 72.095l2.277 6.898L34.156 56.85zm0 0 4.21.13 13.093 36.966m-38.456 15.144-2.51-7.607 2.019-1.278 30.275-18.97 2.93 8.45zm0 0 2.36.073M6.766 89.884l31.74-20.903-2.814-8.126L6.328 81.36 4.37 82.727z"
      stroke="#292747"
      strokeWidth={0.7}
      strokeLinejoin="round"
    />
    <path
      d="m87.851 15.877 14.914 6.663-.689 5.122 4.868 2.056 3.379-3.457 14.326 6.476-7.599 82.398-6.374 6.517-78.083-33.278 18.85-80.477 2.413-2.468 7.358 3.137 3.573-3.654 15.797 7.142-.921 5.088 5.006 2.384z"
      fill="#EAE9ED"
    />
    <path
      d="M87.851 15.877 74.673 97.069m13.178-81.193 14.914 6.664-.689 5.122M87.851 15.877l-3.182 3.649m-9.996 77.543 17.07 7.42m-17.07-7.42-3.476 3.555m20.546 3.865-3.187 3.259 8.05 4.009m-4.863-7.268 10.333-76.827m-5.47 84.095 3.766-3.852m-3.766 3.852 10.338-82.04m-6.572 78.188 9.951-81.644m-9.951 81.644 16.678 7.23m-6.727-88.874 14.326 6.476-7.599 82.398m-6.727-88.874-3.379 3.457m10.106 85.417-6.374 6.517-78.083-33.278m74.351-58.656-4.868-2.056m-17.407-8.136-5.006-2.384m5.006 2.384-13.472 81.098m8.466-83.482.921-5.088-15.797-7.142m14.876 12.23L65.55 93.171m-.763-88.259L47.794 85.467M64.787 4.913l-3.574 3.653m-13.42 76.9L65.55 93.17m-17.756-7.705-3.284 3.357m21.04 4.348-3.283 3.357 8.93 4.096m-26.687-11.8-8.73-3.709m8.73 3.708L61.214 8.566M35.78 85.116 53.856 5.428M35.78 85.115l-3.187 3.26M53.856 5.428l7.358 3.137M53.856 5.43l-2.414 2.468-18.849 80.477"
      stroke="#292747"
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
    <path
      d="m74.673 97.07 13.178-81.193 14.914 6.663-.689 5.122-10.333 76.827zm35.65-70.809-9.951 81.644 16.678 7.23 7.599-82.399zM80.584 12.054l-.921 5.088L65.55 93.171l-17.756-7.705L64.787 4.913z"
      fill="#BFBEC8"
    />
    <path
      d="m117.05 115.135 7.599-82.399-14.326-6.475-9.951 81.644zm0 0-6.374 6.517-78.083-33.278M64.787 4.913l15.797 7.141-.921 5.088L65.55 93.171l-17.756-7.705zm0 0-3.574 3.653m26.638 7.31L74.673 97.07l17.07 7.42 10.333-76.827.689-5.122z"
      stroke="#292747"
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
  </svg>
);
export default SamplesImageBlock;
